import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import useHelpers from 'hooks/helpers';
import { useI18n } from 'next-localization';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import { useFetchRiskAnalysisTabDataQuery } from '@/store/fundDetails/services/fundDetailsApi';
import FundDetailsStripedTable from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsStripedTable';
import useStripedTableHelper from 'hooks/useStripedTableHelper';

const FundDetailsRiskAnalysisTab = () => {
  const { getErrorDictionary } = useHelpers();
  const { t } = useI18n();
  const { shareClass, language, countryCode, correlationFundRangeId, site, fund } = usePayload();
  const { data, error, isLoading } = useFetchRiskAnalysisTabDataQuery(
    {
      shareClass,
      language,
      countryCode,
      correlationFundRangeId,
      site,
      fund,
    },
    {
      skip: !shareClass,
    }
  );

  const { tableData, reportDateFromTo, isScrollable } = useStripedTableHelper(
    data?.content,
    isLoading
  );

  return (
    <FundDetailsTabRow fullWidth className="mt-4">
      <h3>{t('fundDetailsBreakdownRiskTitle')}</h3>
      <div className="mt-5">
        {isLoading ? (
          <FundDetailsTabSkeleton />
        ) : error || data.statusCode !== 200 ? (
          <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
        ) : data.content && data.content.results?.length !== 0 ? (
          <>
            <FundDetailsStripedTable
              reportDate={reportDateFromTo}
              data={tableData}
              minimal={true}
              isScrollable={isScrollable}
              tableId="riskAnalysisTable"
              wrapperId="riskAnalysisWrapper"
            />
            {data.content.footnote && (
              <section>
                <div className="mt-3 py-4 px-2 px-md-3 px-lg-5 background-digital-light-grey">
                  <p
                    className="body-small"
                    dangerouslySetInnerHTML={{ __html: data.content.footnote }}
                  />
                </div>
              </section>
            )}
          </>
        ) : (
          <div className="body-default">{t('noResultsMessage')}</div>
        )}
      </div>
    </FundDetailsTabRow>
  );
};

export default FundDetailsRiskAnalysisTab;
